import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export default class PlayersCountButton extends Component {
  className () {
    return classNames('players_count_button', { active: this.props.count === this.props.selected })
  }

  renderPrice () {
    if (this.props.price) {
      return (
        <div className="price_label">
          starting at ${this.props.price}&nbsp;<span className="per_person"></span>
        </div>
      )
    } else {
      return null
    }
  }

  render () {
    return (
      <button className={this.className()} onClick={() => this.props.onSelect(this.props.count)}>
        <div className="count_label">{this.props.label || this.props.count} <span>Players</span></div>
        {this.renderPrice()}
      </button>
    )
  }
}

PlayersCountButton.propTypes = {
  count: PropTypes.number.isRequired,
  label: PropTypes.string, // absent for flat price rooms, count is rendered instead
  selected: PropTypes.number,
  onSelect: PropTypes.func
}
